import { GetTermsConditionsUseCase } from '@/core/domain/terms-conditions/usecases/getTermsConditions.usecase';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Component({
    selector: 'fe-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TermsConditionsComponent implements OnInit {
    public breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_customer_support',
            url: 'contact-us-and-faqs',
        },
        {
            label: 'fe_breadcrumb_view_questions',
            url: 'questions',
        },
        {
            label: 'fe_breadcrumb_view_terms_conditions',
            url: 'questions/terms-and-conditions',
        },
    ];

    constructor(
        private readonly getTermsConditionsUseCase: GetTermsConditionsUseCase,
    ) {}

    public termsConditionsContent = '';

    public ngOnInit(): void {
        this.getTermsConditionsUseCase
            .execute()
            .pipe(
                switchMap((response) => {
                    this.termsConditionsContent = response.data.termsConditions;
                    return of(response);
                }),
            )
            .subscribe();
    }
}
